import { Link } from 'react-router-dom'
import { dataSimples } from '../../../lib/datas'
import type { OcorrenciaNoIndicador } from '../../../types/chamado'


/**
 * O IAD aberto ocorrência a ocorrência, dentro do cartão do fechamento.
 *
 * A pontuação só é conferível com a lista à vista, pela mesma razão que a razão do ICA só é
 * conferível com a fração: "17 pontos" pode ser uma implantação sem comitê mais duas faltas em
 * reunião, ou três descumprimentos de prazo — e as duas leituras dizem coisas muito diferentes
 * sobre o mês para quem vai assinar o termo de recebimento.
 *
 * Aqui a lista é resumida de propósito: o texto inteiro, a manifestação da contratada e as
 * revogadas ficam na tela do indicador, que é onde se age sobre elas.
 *
 * @param props as ocorrências que formaram a pontuação
 * @returns a lista, ou nada quando o mês não teve ocorrência
 */
export function OcorrenciasDoIad({ ocorrencias }: { ocorrencias: OcorrenciaNoIndicador[] }) {
  if (ocorrencias.length === 0) {
    return null
  }

  return (
    <div className="mt-3 space-y-2">
      <ul className="divide-y divide-slate-100 rounded-lg ring-1 ring-slate-200">
        {ocorrencias.map((o, posicao) => (
          <li
            key={`${o.item}-${o.ocorridoEm}-${posicao}`}
            className="flex flex-wrap items-baseline justify-between gap-x-3 gap-y-1 px-3 py-2 text-xs"
          >
            <div className="min-w-0">
              <span className="font-medium text-slate-900">Item {o.item}</span>{' '}
              <span className="text-slate-500">· {dataSimples(o.ocorridoEm, '')}</span>
              {o.gmudCodigo && <span className="text-slate-500"> · {o.gmudCodigo}</span>}
              <p className="text-slate-600">{o.infracao}</p>
            </div>
            <span className="whitespace-nowrap rounded-full bg-red-50 px-2 py-0.5 font-semibold tabular-nums text-red-900">
              {o.pontos} pts
            </span>
          </li>
        ))}
      </ul>
      <Link to="/iad" className="inline-block text-xs font-medium text-sky-800 hover:underline">
        Abrir os pontos administrativos
      </Link>
    </div>
  )
}
